import { FC, createElement } from 'react';
import { QueryCardProps } from './QueryCard.types';
import {
  AllieCardStyled,
  AllieItemStyled,
  AllieTextStyled,
  NumberCircle,
} from './QueryCard.styles';

export const AllieQueryCard: FC<QueryCardProps> = ({ text, onClick, icon, number, selected }) => {
  const digits = number !== undefined ? number.toString().length : 0;

  return (
    <AllieCardStyled
      radius="xl"
      onClick={onClick}
      selected={selected}
      content={{
        children: (
          <AllieItemStyled detail={false}>
            {number !== undefined && (
              <NumberCircle digits={digits} slot="start">
                {number}
              </NumberCircle>
            )}
            <AllieTextStyled
              type="body1"
              color={selected ? 'primary-60' : 'neutral'}
              style={{ lineHeight: '24px' }}
              weight={selected ? 700 : 400}
            >
              {text}
            </AllieTextStyled>
            {icon &&
              createElement(icon, {
                style: {
                  width: '24px',
                  height: '24px',
                  color: 'var(--allie-color-neutral-70)',
                  flexShrink: 0,
                  alignSelf: 'center',
                  margin: 0,
                },
                slot: 'end',
              })}
          </AllieItemStyled>
        ),
      }}
    ></AllieCardStyled>
  );
};
